import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import ActionButton from "../account/ActionButton";
import { useUtils } from "../../context/UtilsProvider";
import { useArrangement } from "../../context/ArrangementProvider";


function ChangePaymentMethodSelect({
  account,
  consent,
  setConsent,
  setErrorMessage,
  setCurrentSortCode,
  setCurrentAccountNumber,
  selectedMethod,
  setSelectedMethod,
  savePaymentMethod
}) {
  const { capitaliseWords } = useUtils();
  const { plan, paymentMethods } = useArrangement();

  const [ paymentMethodLabels, setPaymentMethodLabels ] = useState([
    { id: 5, label: "Card Payment" },
    { id: 11, label: "Direct Debit" },
    { id: 12, label: "Standing Order" },
    { id: 14, label: "Bank Transfer" },
    { id: 15, label: "Cheque Payment" },
    { id: 31, label: "Postal Order" },
  ]);

  useEffect(() => {
    setPaymentMethodLabels(paymentMethodLabels.map((item) => selectedMethod === item.id ? {
      ...item, checked: true } : item));
  }, []);

  const handleChange = (event) => {
    setSelectedMethod(parseInt(event.target.value));
      // Reset consent, errors & inputs on new selection
    setConsent(false);
    setErrorMessage(null);
    setCurrentSortCode(null);
    setCurrentAccountNumber(null);
  };

  return plan && (
    <>
      <Box
        sx={{
          borderRadius: 1,
          border: "1px solid lightgrey",
          pb: 3,
        }}
      >
        {/* Header section */}
        <Box
          sx={{
            pb: 1,
            borderBottom: "1px solid lightgrey",
            borderRadius: 1,
            backgroundColor: "white",
          }}
        >
          <Container sx={{ width: "100%" }}>
            <Typography fontSize={18} fontWeight={"bold"} paddingY={1}>
              {account?.creditorName}
            </Typography>
            <Typography fontSize={13}>Reference number:</Typography>
            <Typography id='reference-num' fontSize={16} fontWeight={"bold"}>
              {account?.accountReference}
            </Typography>
          </Container>
        </Box>
        {/* End of header section */}

        <Box
          sx={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            mx: 2,
          }}
        >
          <Typography sx={{ fontSize: 14, ml: 1, mt: 2, fontWeight: "bold" }}>
            Select payment method
          </Typography>
          <Typography sx={{ fontSize: 12, ml: 1, mb: 1 }}>
            Current payment method: {capitaliseWords(plan?.paymentMethod ? Object.keys(
              paymentMethods).find(key => paymentMethods[key] === plan?.paymentMethod) : "")}
          </Typography>

          <FormControl>
            <FormLabel id="payment-methods-radio-buttons-group"></FormLabel>
            <RadioGroup
              aria-labelledby="payment-methods-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={selectedMethod}
              onChange={handleChange}
            >
              {paymentMethodLabels.map((item, idx) => (
                <Card key={idx} sx={{
                  mt: 1,
                  mx: 1,
                  px: 2,
                  py: 1,
                  "&:hover": {
                    backgroundColor: "primary.dark",
                    color: "#FFF"
                  }
                }}>
                  <Box>
                    <FormControlLabel value={item.id} control={<Radio />} label={item.label} />
                  </Box>
                </Card>
              ))}
            </RadioGroup>
          </FormControl>

          {/* Call To Action */}
          <Box sx={{ textAlign: "center", pt: 4, pb: 1 }}>
            <ActionButton
              variant='contained'
              buttonColor='secondary.main'
              buttonTextColor='primary.contrastText'
              borderColor='transparent'
              hoverColor='primary.contrastText'
              hoverBorderColor='secondary.main'
              hoverTextColor='secondary.main'
              buttonTitle='Continue'
              disabled={!consent}
              onClick={savePaymentMethod}
            />
          </Box>

        </Box>
      </Box>
    </>
  )
}

export default ChangePaymentMethodSelect;